import React from "react";
function getDateRangeStatus(startDate, endDate) {
  const today = new Date();

  const start = new Date(startDate);
  const end = new Date(endDate);

  // Normalisasi jam agar hanya membandingkan tanggal
  today.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const oneDay = 1000 * 60 * 60 * 24;
  const oneMonthDays = 30;

  // Jika hari ini berada dalam range start - end
  if (today >= start && today <= end) {
    return "";
  }

  // Sebelum start date
  if (today < start) {
    const diffDays = Math.ceil((start - today) / oneDay);

    if (diffDays <= oneMonthDays) {
      if (diffDays >= oneMonthDays) {
        return "1 bulan lagi";
      }

      return `${diffDays} hari lagi`;
    }

    return "";
  }

  // Setelah end date
  if (today > end) {
    const diffDays = Math.ceil((today - end) / oneDay);

    if (diffDays <= oneMonthDays) {
      if (diffDays >= oneMonthDays) {
        return "1 bulan yang lalu";
      }

      return `${diffDays} hari yang lalu`;
    }

    return "";
  }

  return "";
}

const DateRangeStatus = ({ startDate, endDate }) => {
  return <span>{getDateRangeStatus(startDate, endDate)}</span>;
};
export default DateRangeStatus;
